module.exports = __webpack_public_path__ + "static/media/eye.a8714f7c.svg";